define(
({
  "load_error": "ロードエラー",
  "description": "リクエストが正常に完了されませんでした。注文が保存されているかどうかを確認のうえ、このページを更新してください。"
})
);
